module.exports = __webpack_public_path__ + "img/wifi.c89791ce.svg";